import ActionTypes from '../constants/ActionTypes';

/* Actions */

export const createItem = (data) => ({
  type: ActionTypes.ITEM_CREATE,
  payload: {
    data,
  },
});

export const updateItem = (id, data) => ({
  type: ActionTypes.ITEM_UPDATE,
  payload: {
    id,
    data,
  },
});

export const deleteItem = (id) => ({
  type: ActionTypes.ITEM_DELETE,
  payload: {
    id,
  },
});

/* Events */

export const createItemRequested = (data) => ({
  type: ActionTypes.ITEM_CREATE_REQUESTED,
  payload: {
    data,
  },
});

export const createItemSucceeded = (item) => ({
  type: ActionTypes.ITEM_CREATE_SUCCEEDED,
  payload: {
    item,
  },
});

export const createItemFailed = (error) => ({
  type: ActionTypes.ITEM_CREATE_FAILED,
  payload: {
    error,
  },
});

export const createItemReceived = (item) => ({
  type: ActionTypes.ITEM_CREATE_RECEIVED,
  payload: {
    item,
  },
});

export const updateItemRequested = (id, data) => ({
  type: ActionTypes.ITEM_UPDATE_REQUESTED,
  payload: {
    id,
    data,
  },
});

export const updateItemSucceeded = (item) => ({
  type: ActionTypes.ITEM_UPDATE_SUCCEEDED,
  payload: {
    item,
  },
});

export const updateItemFailed = (id, error) => ({
  type: ActionTypes.ITEM_UPDATE_FAILED,
  payload: {
    id,
    error,
  },
});

export const updateItemReceived = (item) => ({
  type: ActionTypes.ITEM_UPDATE_RECEIVED,
  payload: {
    item,
  },
});

export const deleteItemRequested = (id) => ({
  type: ActionTypes.ITEM_DELETE_REQUESTED,
  payload: {
    id,
  },
});

export const deleteItemSucceeded = (item) => ({
  type: ActionTypes.ITEM_DELETE_SUCCEEDED,
  payload: {
    item,
  },
});

export const deleteItemFailed = (id, error) => ({
  type: ActionTypes.ITEM_DELETE_FAILED,
  payload: {
    id,
    error,
  },
});

export const deleteItemReceived = (item) => ({
  type: ActionTypes.ITEM_DELETE_RECEIVED,
  payload: {
    item,
  },
});
